import React from 'react';
import {
  Box,
  Button,
  CardHeader, Divider,
  Grid,
  InputLabel,
  TextField
} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { Formik } from 'formik';
import MaterialTable from 'material-table';
import { useEffect, useRef, useState } from 'react';
import * as Yup from "yup";
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import { Paper } from '@material-ui/core';
import { useAlert } from "react-alert";

export default function Rolling({ handleNext, handleBack, manufacturingDetail, rollingDetails, setRollingDetails,
  witheringDetails, factoryID, isUpdate, StatusID }) {
  const [selectedDhools, setSelectedDhools] = useState([]);
  const [showDhoolDropdown, setShowDhoolDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const alert = useAlert();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDhoolDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isUpdate) {
      let initialSelected = [];
      if (rollingDetails.selectedDhools && rollingDetails.selectedDhools.length > 0) {
        initialSelected = rollingDetails.selectedDhools.map(dhool => dhool.dhoolID);
      } else if (rollingDetails.noOfDhool) {
        initialSelected = dhoolChipList
          .slice(0, Math.min(rollingDetails.noOfDhool, dhoolChipList.length))
          .map(item => item.dhoolID);
      }
      if (!initialSelected.includes(0)) {
        initialSelected.push(0);
      }

      if (JSON.stringify(initialSelected) !== JSON.stringify(selectedDhools)) {
        setSelectedDhools(initialSelected);

        const selectedDhoolObjects = dhoolChipList.filter(item =>
          initialSelected.includes(item.dhoolID)
        );
        setRollingDetails(prevDetails => ({
          ...prevDetails,
          selectedDhools: selectedDhoolObjects,
          noOfDhool: selectedDhoolObjects.length
        }));
      }
    }
  }, [isUpdate, rollingDetails.selectedDhools, rollingDetails.noOfDhool, selectedDhools]);

  useEffect(() => {
    if (isUpdate && rollingDetails.noOfBatch == 0) {
      setRollingDetails(prevDetails => ({
        ...prevDetails,
        rollingStartTime: witheringDetails.endDate,
        rollingEndDate: witheringDetails.endDate
      }));

    }
  }, [witheringDetails.endDate]);
  useEffect(() => {
    if (showDhoolDropdown) {
      const handleScroll = () => {
        setShowDhoolDropdown(false);
      };

      const preventScroll = (e) => {
        e.preventDefault();
      };

      window.addEventListener('scroll', handleScroll);
      document.body.style.overflow = 'hidden';
      document.addEventListener('wheel', preventScroll, { passive: false });

      return () => {
        window.removeEventListener('scroll', handleScroll);
        document.body.style.overflow = '';
        document.removeEventListener('wheel', preventScroll);
      };
    }
  }, [showDhoolDropdown]);

  useEffect(() => {
    if (isUpdate) {
      let newSelected = [];
      if (rollingDetails.selectedDhools && rollingDetails.selectedDhools.length > 0) {
        newSelected = rollingDetails.selectedDhools.map(dhool => dhool.dhoolID);
      } else if (rollingDetails.noOfDhool) {
        newSelected = dhoolChipList
          .slice(0, Math.min(rollingDetails.noOfDhool, dhoolChipList.length))
          .map(item => item.dhoolID);
      }

      if (!newSelected.includes(0)) {
        newSelected.push(0);
      }

      if (JSON.stringify(newSelected) !== JSON.stringify(selectedDhools)) {
        setSelectedDhools(newSelected);

        const selectedDhoolObjects = dhoolChipList.filter(item =>
          newSelected.includes(item.dhoolID)
        );
        setRollingDetails(prevDetails => ({
          ...prevDetails,
          selectedDhools: selectedDhoolObjects,
          noOfDhool: selectedDhoolObjects.length
        }));
      }
    }
  }, [isUpdate, rollingDetails.selectedDhools, rollingDetails.noOfDhool, selectedDhools]);

  useEffect(() => {
    if (rollingDetails.selectedDhools && rollingDetails.selectedDhools.length > 0) {
      const newSelected = rollingDetails.selectedDhools.map(dhool => dhool.dhoolID);
      if (JSON.stringify(newSelected) !== JSON.stringify(selectedDhools)) {
        setSelectedDhools(newSelected);
        setRollingDetails(prevDetails => ({
          ...prevDetails,
          noOfDhool: newSelected.length
        }));
      }
    }
  }, [rollingDetails.selectedDhools, selectedDhools]);

  useEffect(() => {
    if (witheringDetails.endDate && !rollingDetails.rollingStartTime) {
      const startDate = new Date(witheringDetails.endDate);
      const formattedStart = formatDateTime(startDate);

      const endDate = new Date(startDate);
      const formattedEnd = formatDateTime(endDate);

      setRollingDetails(prev => ({
        ...prev,
        rollingStartTime: formattedStart,
        rollingEndDate: formattedEnd
      }));
    }
  }, [witheringDetails.endDate]);

  useEffect(() => {
    if (new Date(rollingDetails.rollingEndDate) <= new Date(rollingDetails.rollingStartTime)) {
      const newEndDate = new Date(rollingDetails.rollingStartTime);
      const formattedEndDate = formatDateTime(newEndDate);
      setRollingDetails((prevState) => ({
        ...prevState,
        rollingEndDate: formattedEndDate
      }));
    }
  }, [rollingDetails.rollingStartTime]);

  function handleChange(e) {
    const target = e.target;
    const value = target.value

    if (e.target.name != "noOfDhool" && e.target.name != "noOfBatch") {
      setRollingDetails({
        ...rollingDetails,
        [e.target.name]: value
      });
    }
    else {
      const finalValue = value == "" ? parseFloat(0) : value
      var reg = new RegExp('^[0-9]{0,9}([.]?[0-9]{0,2})?$');
      if (reg.test(finalValue) == false) {
        return;
      }
      setRollingDetails({
        ...rollingDetails,
        [e.target.name]: finalValue == "" ? parseFloat(0) : parseFloat(finalValue)
      });
    }
  };

  const handleDhoolSelect = (dhoolID) => {
    if (dhoolID === 0) {
      return;
    }

    if (dhoolID > 1 && !selectedDhools.includes(dhoolID - 1)) {
      alert.error(`Please select Dhool ${dhoolID - 1} before selecting Dhool ${dhoolID}.`);
      return;
    }

    if (selectedDhools.includes(dhoolID)) {
      const higherDhoolsSelected = selectedDhools.filter(id => id > dhoolID);
      if (higherDhoolsSelected.length > 0) {
        alert.error(`Please remove Dhool ${Math.max(...higherDhoolsSelected)} before removing Dhool ${dhoolID}.`);
        return;
      }
    }

    const newSelected = selectedDhools.includes(dhoolID)
      ? selectedDhools.filter(id => id !== dhoolID)
      : [...selectedDhools, dhoolID];
    if (!newSelected.includes(0)) {
      newSelected.push(0);
    }

    setSelectedDhools(newSelected);
    const selectedDhoolObjects = dhoolChipList.filter(item =>
      newSelected.includes(item.dhoolID)
    );

    setRollingDetails({
      ...rollingDetails,
      selectedDhools: selectedDhoolObjects,
      noOfDhool: newSelected.length
    });
  };

  const toggleDhoolDropdown = () => {
    if ((!isUpdate || manufacturingDetail.statusID == 1) && StatusID !== 2 && StatusID !== 3) {
      setShowDhoolDropdown(!showDhoolDropdown);
    }
  };

  const handleNextWithDhools = () => {
    const selectedDhoolObjects = dhoolChipList.filter(item =>
      selectedDhools.includes(item.dhoolID)
    );

    setRollingDetails(prevDetails => ({
      ...prevDetails,
      selectedDhools: selectedDhoolObjects,
      noOfDhool: selectedDhoolObjects.length
    }));

    handleNext();
  };

  const dhoolChipList = [
    { dhoolID: 1, dhoolName: 'Dhool 1' },
    { dhoolID: 2, dhoolName: 'Dhool 2' },
    { dhoolID: 3, dhoolName: 'Dhool 3' },
    { dhoolID: 4, dhoolName: 'Dhool 4' },
    { dhoolID: 5, dhoolName: 'Dhool 5' },
    { dhoolID: 6, dhoolName: 'Dhool 6' },
    { dhoolID: 7, dhoolName: 'Dhool 7' },
    { dhoolID: 8, dhoolName: 'Dhool 8' },
    { dhoolID: 9, dhoolName: 'Dhool 9' },
    { dhoolID: 0, dhoolName: 'Big Bulk' },
  ];

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const formatDateTime = (date) => {
    if (!date) return "";
    const d = new Date(date);

    const pad = n => n.toString().padStart(2, '0');
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <Formik
      initialValues={{
        witheredLeafAmount: rollingDetails.witheredLeafAmount,
        noOfDhool: rollingDetails.noOfDhool,
        noOfBatch: rollingDetails.noOfBatch,
        rollingStartTime: rollingDetails.rollingStartTime,
        rollingEndDate: rollingDetails.rollingEndDate
      }}
      validationSchema={
        Yup.object().shape({
          noOfBatch: Yup.number().required('No of Batch is required').min(1, 'No of Batch should be grater than 0'),
          rollingStartTime: Yup.string().required('Rolling Start Date is required'),
          rollingEndDate: Yup.string().required('Rolling End Date is required'),
          noOfDhool: Yup.number()
            .test('big-bulk-and-another', 'Big Bulk and at least one other Dhool must be selected', function () {
              return selectedDhools.includes(0) && selectedDhools.some(dhool => dhool !== 0);
            })
            .required('At least one Dhool must be selected')
        })
      }
      enableReinitialize
    >
      {({
        errors,
        handleBlur,
        handleSubmit,
        touched,
        setTouched,
        validateForm
      }) => (
        <form onSubmit={handleSubmit}>
          <>
            <CardHeader title={"Rolling"} />
            <Divider />
            &nbsp;
            <Grid container spacing={3}>
              <Grid item md={3} xs={8}>
                <InputLabel shrink id="witheredLeafAmount">
                  {rollingDetails.manufactureTypeCode != "03" ?
                    "Withered Leaf(KG) *" : "Refuse Tea (Kg) *"}
                </InputLabel>
                <TextField
                  fullWidth
                  name="witheredLeafAmount"
                  variant="outlined"
                  id="witheredLeafAmount"
                  size="small"
                  value={witheringDetails.witheredLeafAmount}
                  InputProps={{
                    readOnly: true,
                    inputProps: {
                      step: 0.01,
                      type: 'number',
                      style: {
                        textAlign: 'right',
                      },
                    },
                  }}
                  onKeyDown={(evt) =>
                    (evt.key === "-") && evt.preventDefault()
                  }
                  onWheel={event => event.target.blur()}
                />
              </Grid>
              <Grid item md={3} xs={8} ref={dropdownRef}>
                <InputLabel shrink id="noOfDhool">
                  No of Dhool *
                </InputLabel>
                <TextField
                  error={Boolean(touched.noOfDhool && errors.noOfDhool)}
                  fullWidth
                  helperText={touched.noOfDhool && errors.noOfDhool}
                  name="noOfDhool"
                  onBlur={handleBlur}
                  size='small'
                  value={selectedDhools.length > 0 ? `${selectedDhools.length} selected` : ''}
                  variant="outlined"
                  id="noOfDhool"
                  InputProps={{
                    readOnly: true,
                  }}
                  onClick={toggleDhoolDropdown}
                  disabled={isUpdate && manufacturingDetail.statusID != 1}
                />
                {showDhoolDropdown && (
                  <Box
                    onWheel={(e) => {
                      e.currentTarget.scrollTop += e.deltaY; // <- Mouse wheel scroll handler
                    }}
                    style={{
                      position: 'absolute',
                      zIndex: 1,
                      top: dropdownRef.current?.getBoundingClientRect().bottom + window.scrollY,
                      left: dropdownRef.current?.getBoundingClientRect().left + window.scrollX,
                      width: dropdownRef.current?.offsetWidth || '100%',
                      backgroundColor: 'white',
                      border: '1px solid #ccc',
                      borderRadius: 4,
                      padding: 8,
                      boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                      maxHeight: 200,
                      overflowY: 'overlay',
                    }}
                  >
                    {dhoolChipList.map((item) => (
                      <Box
                        key={item.dhoolID}
                        onClick={() => handleDhoolSelect(item.dhoolID)}
                        style={{
                          padding: '8px',
                          cursor: 'pointer',
                          backgroundColor: selectedDhools.includes(item.dhoolID) ? '#e3f2fd' : 'transparent',
                          borderRadius: 4,
                        }}
                      >
                        <Chip
                          variant={selectedDhools.includes(item.dhoolID) ? "filled" : "outlined"}
                          size="small"
                          label={item.dhoolName}
                          color="primary"
                          style={{
                            margin: '2px',
                            backgroundColor: selectedDhools.includes(item.dhoolID) ? '#3f51b5' : '',
                            color: selectedDhools.includes(item.dhoolID) ? '#fff' : ''
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
              </Grid>
              <Grid item md={3} xs={8}>
                <InputLabel shrink id="noOfBatch">
                  No of Batch *
                </InputLabel>
                <TextField
                  error={Boolean(touched.noOfBatch && errors.noOfBatch)}
                  fullWidth
                  helperText={touched.noOfBatch && errors.noOfBatch}
                  name="noOfBatch"
                  type='number'
                  onBlur={handleBlur}
                  onChange={(e) => handleChange(e)}
                  size='small'
                  value={rollingDetails.noOfBatch}
                  variant="outlined"
                  id="noOfBatch"
                  InputProps={{
                    readOnly: StatusID == 2 || StatusID == 3,
                    inputProps: {
                      step: 1,
                      type: 'number',
                      style: {
                        textAlign: 'right',
                      },
                    },
                  }}
                  onKeyDown={(evt) =>
                    (evt.key === "-") && evt.preventDefault()
                  }
                  onWheel={event => event.target.blur()}
                >
                </TextField>
              </Grid>
              <Grid item md={3} xs={8}>
                <InputLabel shrink id="rollingStartTime">
                  Start Date & Time *
                </InputLabel>
                <TextField
                  fullWidth
                  error={Boolean(touched.rollingStartTime && errors.rollingStartTime)}
                  helperText={touched.rollingStartTime && errors.rollingStartTime}
                  name="rollingStartTime"
                  type="datetime-local"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onBlur={handleBlur}
                  onChange={(e) => handleChange(e)}
                  value={rollingDetails.rollingStartTime}
                  variant="outlined"
                  id="rollingStartTime"
                  size='small'
                  onKeyDown={onKeyDown}
                  inputProps={{
                    min: witheringDetails.endDate,
                    max: formatDateTime(manufacturingDetail.toDateOfManufacture)
                  }}
                  InputProps={{
                    readOnly: StatusID == 2 || StatusID == 3
                  }}
                >
                </TextField>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item md={3} xs={8}>
                <InputLabel shrink id="rollingEndDate">
                  End Date & Time *
                </InputLabel>
                <TextField
                  fullWidth
                  error={Boolean(touched.rollingEndDate && errors.rollingEndDate)}
                  helperText={touched.rollingEndDate && errors.rollingEndDate}
                  type="datetime-local"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="rollingEndDate"
                  onBlur={handleBlur}
                  onChange={(e) => handleChange(e)}
                  value={rollingDetails.rollingEndDate}
                  variant="outlined"
                  id="rollingEndDate"
                  size='small'
                  inputProps={{
                    max: formatDateTime(manufacturingDetail.toDateOfManufacture),
                    min: rollingDetails.rollingStartTime
                  }}
                  onKeyDown={onKeyDown}
                  InputProps={{
                    readOnly: StatusID == 2 || StatusID == 3
                  }}
                >
                </TextField>
              </Grid>
            </Grid>
            <br />
            {selectedDhools.length > 0 && (
              <Grid item spacing={3} md={12} xs={12} mt={2} container>
                <Grid item md={3} xs={12}>
                  <MaterialTable
                    title={
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <PlaylistAddCheckIcon style={{ marginRight: 8, color: '#5c6bc0' }} />
                        <span style={{ fontSize: '1.1rem', fontWeight: 600, color: '#3f51b5' }}>
                          Selected Dhools
                        </span>
                      </div>
                    }
                    columns={[
                      {
                        title: 'Dhool',
                        field: 'dhoolName',
                        headerStyle: {
                          backgroundColor: '#f5f5f5',
                          fontWeight: 'bold',
                          fontSize: '0.95rem',
                          paddingLeft: '16px'
                        },
                        cellStyle: {
                          paddingLeft: '16px',
                          fontWeight: 500,
                          borderLeft: '3px solid #5c6bc0'
                        }
                      }
                    ]}
                    data={dhoolChipList.filter(item => selectedDhools.includes(item.dhoolID))}
                    options={{
                      search: false,
                      paging: false,
                      sorting: false,
                      toolbar: false,
                      headerStyle: {
                        backgroundColor: '#f5f5f5',
                        fontWeight: 'bold',
                      },
                      rowStyle: {
                        backgroundColor: '#fafafa',
                        '&:hover': {
                          backgroundColor: '#f0f0f0'
                        }
                      },
                      padding: 'dense',
                      maxBodyHeight: '400px',
                      showTitle: true
                    }}
                    localization={{
                      body: {
                        emptyDataSourceMessage: 'No dhools selected'
                      }
                    }}
                    components={{
                      Container: props => (
                        <Paper
                          elevation={2}
                          style={{
                            borderRadius: '8px',
                            overflow: 'hidden',
                            border: '1px solid #e0e0e0'
                          }}
                          {...props}
                        />
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            )}
            &nbsp;
            <Box display="flex" justifyContent="flex-end">
              {rollingDetails.manufactureTypeCode != "03" ?
                <Button
                  color="primary"
                  variant="contained"
                  type='button'
                  size='small'
                  onClick={handleBack}
                >
                  Back
                </Button> : null}
              &nbsp;
              <Button
                color="primary"
                variant="contained"
                type='button'
                size='small'
                onClick={async () => {
                  await setTouched({
                    witheredLeafAmount: true,
                    noOfDhool: true,
                    noOfBatch: true,
                    rollingStartTime: true,
                    rollingEndDate: true
                  });
                  const formErrors = await validateForm();
                  if (Object.keys(formErrors).length === 0) {
                    handleNextWithDhools();
                  }
                }}
              >
                Next
              </Button>
            </Box>
          </>
        </form>
      )}
    </Formik >
  )
}
